import React from 'react';
import {connect} from "react-redux";
import {actions, Errors, Form} from "react-redux-form";
import {updateOrderLimit} from "../../../../actions/order-limits";
import {Col, Row} from "react-bootstrap";
import RequiredRadioGroup from "../../../common/form/elements/required-radio-group";
import ArrowButton from "../../../common/button-arrow";
import DatePicker from "../../../common/form/datepicker";
import RequiredMultiSelect from "../../../common/form/elements/required-multi-select";

import './styles.css'
import {toast} from "react-toastify";
import ToastMessage from "../../../common/toast-message";

const OrderLimitEditForm = ({dispatch, orderLimit, ...props}) => {
  const monthly = orderLimit.attributes['transaction-type'] === 'monthly maximum';
  const adhoc = orderLimit.attributes['transaction-type'] === 'adhoc maximum';

  const onSubmit = (payLoad) => {
    dispatch(actions.submitFields('deep.admin_order_limit', updateOrderLimit(orderLimit.id, payLoad)))
      .catch((error) => {
        dispatch({ type: 'SAVE_ORDER_LIMIT_REJECTED', payLoad: error.response.data });
        toast.error(<ToastMessage iconStyle="error" message="An error occurred during save Order Limit"/>);
        if (error.response.data.errors) {
          const errors = error.response.data.errors;
          ['end_date'].forEach((field) => {
            if (errors[field]) {
              dispatch(actions.setErrors(`deep.admin_order_limit.${field}`, errors[field]));
            }
          });
        }
      });
  };
  return (
    <Form model="deep.admin_order_limit" onSubmit={onSubmit}>
      <Row>
        <Col lg={12}>Order limit type</Col>
      </Row>
      <Row>
        <Col lg={12}>{orderLimit.attributes['transaction-type']}</Col>
      </Row>
      <Row>
        <Col lg={6}>
          <RequiredMultiSelect
            data={props.categories.map(category => {return {id: category.id, name: category.attributes.name}})}
            value={props.selectedCategories}
            label="Categories"
            labelAttr="name"
            valueAttr="id"
            controlId="orderLimitCategory"
            model='deep.admin_order_limit.categories'
          />
        </Col>
      </Row>
      {monthly && (<Row>
          <Col lg={12}>Set live?</Col>
        </Row>)}
      {monthly && (<Row>
        <Col lg={12}>
          <RequiredRadioGroup
            model="deep.admin_order_limit.active"
            radios={props.active}
            controlId="orderLimitActive"/>
        </Col>
      </Row>)}
      {adhoc && (<Row>
        <Col lg={4}>
          <DatePicker
            label='Start date'
            placeholder='Start date'
            model="deep.admin_order_limit.start_date"
            controlId="orderLimitStartDate"
            value={props.startDate}/>
        </Col>
      </Row>)}
      {adhoc && (<Row>
        <Col lg={4}>
          <DatePicker
            label='End date'
            placeholder='End date'
            model="deep.admin_order_limit.end_date"
            controlId="orderLimitEndDate"
            value={props.endDate}/>
          <Errors
            show={{touched: true, focus: false}}
            className="errors"
            model="deep.admin_order_limit.end_date"
          />
        </Col>
      </Row>)}
      <Row>
        <Col lg={12}>
          <ArrowButton
            color="grey"
            className="pull-right"
            disabled={!props.formValid}
          >
            Save
          </ArrowButton>
        </Col>
      </Row>
    </Form>
  )
};

const mapStateToProps = (state) => {
  return {
    active: state.orderLimits.editorInput.active || [],
    categories: state.orderLimits.editorInput.categories || [],
    selectedCategories: state.deep.admin_order_limit.categories,
    selectedActive: state.deep.admin_order_limit.active,
    startDate: state.deep.admin_order_limit.start_date,
    endDate: state.deep.admin_order_limit.end_date,
    formValid: state.deep.forms.admin_order_limit.$form.valid
  };
};

export default connect(mapStateToProps)(OrderLimitEditForm);



// WEBPACK FOOTER //
// ./src/components/admin/order-limits/edit/order-limit-edit-form.jsx